/**
 * Shape of the runtime-injected environment object produced by `env.sh`
 * and attached to `window.__env__` at container startup.
 */
type RuntimeEnv = Record<string, string>;

/**
 * Reads a `REACT_APP_*` variable, preferring the runtime-injected
 * `window.__env__` value (set by `env.sh`) and falling back to the
 * build-time `process.env` value.
 *
 * Uses `||` (not `??`) so an empty string injected for an unset variable
 * correctly falls through to the build-time value.
 */
export const getRuntimeEnv = (key: string): string | undefined => {
  const runtimeEnv = (window as unknown as { __env__?: RuntimeEnv }).__env__;
  return runtimeEnv?.[key] || process.env[key] || undefined;
};
